<template>
  <div class="page">
    <breadcrumb></breadcrumb>
    <div class="resume-form">
      <el-form
        ref="resumeForm"
        :model="formData"
        :rules="rules"
        label-width="180px"
        class="resume-form-content"
      >
        <!-- 个人基本信息 -->
        <div class="form-section">
          <h2 class="section-title">个人基本信息</h2>

          <div class="form-row">
            <el-form-item label="姓名" prop="nickName">
              <el-input
                v-model="formData.nickName"
                placeholder="请输入姓名"
                clearable
              />
            </el-form-item>
            <el-form-item label="个人免冠照片" prop="personalPhoto" required>
              <el-upload
                :action="uploadUrl"
                :on-success="
                  (response, file, fileList) =>
                    handleUploadSuccess(
                      'personalPhoto',
                      response,
                      file,
                      fileList
                    )
                "
                :on-error="handleUploadError"
                :before-upload="(file) => beforeUpload(uploadType, file)"
                :limit="1"
                :file-list="personalPhotoList"
                :on-exceed="handleExceed"
                :on-remove="
                  (file, fileList) =>
                    handleRemove('personalPhoto', file, fileList)
                "
                :accept="accept"
              >
                <el-button
                  type="success"
                  size="small"
                  @click="submitUpload('image')"
                >
                  上传图片
                </el-button>
              </el-upload>
              <div v-if="formData.personalPhoto" class="image-preview">
                <img
                  :src="formData.personalPhoto"
                  alt="个人免冠照片"
                  @error="handleImageError('personalPhoto')"
                />
              </div>
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input
                v-model="formData.idNumber"
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
            <el-form-item label="电话号码" prop="phonenumber">
              <el-input
                v-model="formData.phonenumber"
                placeholder="请输入电话号码"
                maxlength="11"
              >
                <template slot="prepend">+86</template>
              </el-input>
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item label="性别" prop="gender">
              <el-select
                v-model="formData.gender"
                placeholder="请选择性别"
                style="width: 100%"
              >
                <el-option label="男" value="男" />
                <el-option label="女" value="女" />
              </el-select>
            </el-form-item>
            <el-form-item label="民族" prop="ethnicity">
              <el-select
                v-model="formData.ethnicity"
                placeholder="请选择民族"
                style="width: 100%"
              >
                <el-option label="汉族" value="汉族" />
                <el-option label="蒙古族" value="蒙古族" />
                <el-option label="回族" value="回族" />
                <el-option label="藏族" value="藏族" />
                <el-option label="维吾尔族" value="维吾尔族" />
                <el-option label="苗族" value="苗族" />
                <el-option label="彝族" value="彝族" />
                <el-option label="壮族" value="壮族" />
                <el-option label="布依族" value="布依族" />
                <el-option label="朝鲜族" value="朝鲜族" />
                <el-option label="满族" value="满族" />
                <el-option label="侗族" value="侗族" />
                <el-option label="瑶族" value="瑶族" />
                <el-option label="白族" value="白族" />
                <el-option label="土家族" value="土家族" />
                <el-option label="哈尼族" value="哈尼族" />
                <el-option label="哈萨克族" value="哈萨克族" />
                <el-option label="傣族" value="傣族" />
                <el-option label="黎族" value="黎族" />
                <el-option label="僳僳族" value="僳僳族" />
                <el-option label="佤族" value="佤族" />
                <el-option label="畲族" value="畲族" />
                <el-option label="高山族" value="高山族" />
                <el-option label="拉祜族" value="拉祜族" />
                <el-option label="水族" value="水族" />
                <el-option label="东乡族" value="东乡族" />
                <el-option label="纳西族" value="纳西族" />
                <el-option label="景颇族" value="景颇族" />
                <el-option label="柯尔克孜族" value="柯尔克孜族" />
                <el-option label="土族" value="土族" />
                <el-option label="达斡尔族" value="达斡尔族" />
                <el-option label="仫佬族" value="仫佬族" />
                <el-option label="羌族" value="羌族" />
                <el-option label="布朗族" value="布朗族" />
                <el-option label="撒拉族" value="撒拉族" />
                <el-option label="毛南族" value="毛南族" />
                <el-option label="仡佬族" value="仡佬族" />
                <el-option label="锡伯族" value="锡伯族" />
                <el-option label="阿昌族" value="阿昌族" />
                <el-option label="普米族" value="普米族" />
                <el-option label="塔吉克族" value="塔吉克族" />
                <el-option label="怒族" value="怒族" />
                <el-option label="乌孜别克族" value="乌孜别克族" />
                <el-option label="俄罗斯族" value="俄罗斯族" />
                <el-option label="鄂温克族" value="鄂温克族" />
                <el-option label="德昂族" value="德昂族" />
                <el-option label="保安族" value="保安族" />
                <el-option label="裕固族" value="裕固族" />
                <el-option label="京族" value="京族" />
                <el-option label="塔塔尔族" value="塔塔尔族" />
                <el-option label="独龙族" value="独龙族" />
                <el-option label="鄂伦春族" value="鄂伦春族" />
                <el-option label="赫哲族" value="赫哲族" />
                <el-option label="门巴族" value="门巴族" />
                <el-option label="珞巴族" value="珞巴族" />
                <el-option label="基诺族" value="基诺族" />
              </el-select>
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item label="出生日期" prop="birthDate">
              <el-date-picker
                v-model="formData.birthDate"
                type="date"
                placeholder="选择出生日期"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="政治面貌" prop="politicalStatus">
              <el-select
                v-model="formData.politicalStatus"
                placeholder="请选择政治面貌"
                style="width: 100%"
              >
                <el-option label="中国共产党党员" value="中国共产党党员" />
                <el-option
                  label="中国共产党预备党员"
                  value="中国共产党预备党员"
                />
                <el-option
                  label="中国共产主义青年团团员"
                  value="中国共产主义青年团团员"
                />
                <el-option
                  label="中国国民党革命委员会党员"
                  value="中国国民党革命委员会党员"
                />
                <el-option label="中国民主同盟盟员" value="中国民主同盟盟员" />
                <el-option
                  label="中国民主建国会会员"
                  value="中国民主建国会会员"
                />
                <el-option
                  label="中国民主促进会会员"
                  value="中国民主促进会会员"
                />
                <el-option
                  label="中国农工民主党党员"
                  value="中国农工民主党党员"
                />
                <el-option label="中国致公党党员" value="中国致公党党员" />
                <el-option label="九三学社社员" value="九三学社社员" />
                <el-option
                  label="台湾民主自治同盟盟员"
                  value="台湾民主自治同盟盟员"
                />
                <el-option label="无党派民主人士" value="无党派民主人士" />
                <el-option label="群众" value="群众" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item label="最高学历" prop="highestEducation">
              <el-select
                v-model="formData.highestEducation"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="小学" value="小学" />
                <el-option label="初中" value="初中" />
                <el-option label="高中" value="高中" />
                <el-option label="中专" value="中专" />
                <el-option label="大专" value="大专" />
                <el-option label="本科" value="本科" />
                <el-option label="硕士研究生" value="硕士研究生" />
                <el-option label="博士研究生" value="博士研究生" />
              </el-select>
            </el-form-item>
            <el-form-item label="所学专业" prop="major">
              <el-input
                v-model="formData.major"
                placeholder="请输入所学专业"
                clearable
              />
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="formData.email"
                placeholder="邮箱"
                type="email"
                style="width: 41%"
              />
            </el-form-item>
          </div>
        </div>

        <!-- 社会工作信息 -->
        <div class="form-section">
          <h2 class="section-title">社会工作信息</h2>

          <div class="form-row">
            <el-form-item label="单位性质" prop="unitNature">
              <el-select
                v-model="formData.unitNature"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="基层自治组织" value="基层自治组织" />
                <el-option label="行政事业单位" value="行政事业单位" />
                <el-option label="社会组织" value="社会组织" />
                <el-option label="社区备案组织" value="社区备案组织" />
                <el-option label="本协会会员" value="本协会会员" />
              </el-select>
            </el-form-item>
            <el-form-item label="单位名称" prop="unitName">
              <el-input
                v-model="formData.unitName"
                placeholder="单位名称"
                clearable
              />
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item label="职称" prop="professionalTitle">
              <el-input
                v-model="formData.professionalTitle"
                placeholder="请输入职称"
                clearable
              />
            </el-form-item>
            <el-form-item label="现任职务" prop="position">
              <el-cascader
                v-model="formData.position"
                :options="position"
                style="width: 100%"
                placeholder="请选择现任职务"
                v-if="formData.unitNature === '基层自治组织'"
              ></el-cascader>
              <el-input
                v-model="formData.position"
                placeholder="请输入现任职务"
                clearable
                v-else
              />
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item
              label="证明资料"
              prop="supportingDocuments"
              v-if="
                formData.unitNature === '行政事业单位' ||
                formData.unitNature === '社会组织' ||
                formData.unitNature === '社区备案组织'
              "
            >
              <el-upload
                :action="uploadUrl"
                :on-error="handleUploadError"
                :before-upload="(file) => beforeUpload(uploadType, file)"
                :file-list="supportingDocumentsList"
                multiple
                :accept="accept"
                :on-success="
                  (response, file, fileList) =>
                    handleUploadSuccess(
                      'supportingDocuments',
                      response,
                      file,
                      fileList
                    )
                "
                :on-remove="
                  (file, fileList) =>
                    handleRemove('supportingDocuments', file, fileList)
                "
                :on-preview="handlePreview"
              >
                <div v-if="formData.unitNature === '行政事业单位'">
                  <el-button
                    type="success"
                    size="small"
                    @click="submitUpload('pdf')"
                  >
                    上传证明单位
                  </el-button>
                  <div slot="tip" class="el-upload__tip">
                    <el-link
                      icon="el-icon-download"
                      @click.stop="
                        onDownload(
                          'https://oss-community.planttech.cn/huacheng/dc2cac23b6df5d53506ccfdd854d1dce/d3fc10710a084209a76fa19ed8482c44.docx'
                        )
                      "
                    >
                      下载证明单位模板
                    </el-link>
                  </div>
                </div>
                <div v-else-if="formData.unitNature === '社会组织'">
                  <el-button
                    slot="trigger"
                    size="small"
                    type="primary"
                    @click="submitUpload('pdf')"
                  >
                    上传社会组织证明
                  </el-button>
                  <el-button
                    style="margin-left: 10px"
                    size="small"
                    type="success"
                    @click="submitUpload('image')"
                  >
                    上传社会组织证书
                  </el-button>
                  <div slot="tip" class="el-upload__tip">
                    <el-link
                      icon="el-icon-download"
                      @click.stop="
                        onDownload(
                          'https://oss-community.planttech.cn/huacheng/dc2cac23b6df5d53506ccfdd854d1dce/d3fc10710a084209a76fa19ed8482c44.docx'
                        )
                      "
                    >
                      下载社会组织证明模板
                    </el-link>
                  </div>
                </div>
                <div v-else-if="formData.unitNature === '社区备案组织'">
                  <el-button
                    type="success"
                    size="small"
                    @click="submitUpload('pdf')"
                  >
                    上传备案表
                  </el-button>
                </div>
                <el-button type="success" size="small" :disabled="true" v-else>
                  无需上传证明资料
                </el-button>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="证明资料"
              prop="memberCode"
              v-else-if="formData.unitNature === '本协会会员'"
            >
              <div>
                <el-input
                  v-model="formData.memberCode"
                  placeholder="请输入会员编码"
                  clearable
                  style="width: 80.5%"
                  @blur="() => $refs.resumeForm.validateField('memberCode')"
                />
                <el-button
                  style="margin-left: 10px"
                  type="success"
                  size="small"
                  @click="submitApplication('/register/applyMembership')"
                >
                  申请入会
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="证明资料" v-else>
              <el-button type="success" size="small" :disabled="true">
                无需上传证明资料
              </el-button>
            </el-form-item>

            <el-form-item
              label="社会工作者证书等级"
              prop="socialWorkerCertificateLevel"
            >
              <el-select
                v-model="formData.socialWorkerCertificateLevel"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="助理" value="助理" />
                <el-option label="中级" value="中级" />
                <el-option label="高级" value="高级" />
              </el-select>
            </el-form-item>
          </div>

          <div class="form-row">
            <el-form-item label="等级证书" prop="certificateUpload">
              <el-upload
                :action="uploadUrl"
                :on-success="
                  (response, file, fileList) =>
                    handleUploadSuccess(
                      'certificateUpload',
                      response,
                      file,
                      fileList
                    )
                "
                :on-error="handleUploadError"
                :before-upload="(file) => beforeUpload(uploadType, file)"
                :file-list="certificateUploadList"
                :on-remove="
                  (file, fileList) =>
                    handleRemove('certificateUpload', file, fileList)
                "
                :accept="accept"
                multiple
              >
                <el-button
                  type="success"
                  size="small"
                  @click="submitUpload('image')"
                >
                  上传等级证书
                </el-button>
              </el-upload>
              <div
                v-if="
                  formData.certificateUpload &&
                  formData.certificateUpload.length > 0
                "
                class="image-preview"
              >
                <img
                  v-for="(img, index) in formData.certificateUpload"
                  :key="index"
                  :src="img"
                  :alt="'等级证书' + (index + 1)"
                  @error="handleImageError('certificateUpload', index)"
                />
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- 提交说明 -->
        <div class="form-section">
          <h2 class="section-title">提交说明</h2>

          <el-form-item label="提交说明">
            <el-input
              v-model="formData.remark"
              type="textarea"
              :rows="4"
              placeholder="请输入提交说明"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </div>

        <!-- 表单操作 -->
        <div class="form-actions">
          <el-button
            type="warning"
            @click="submitForm"
            :loading="loading"
            size="large"
          >
            {{ loading ? "提交中..." : "提交登记" }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb.vue";
import { register } from "@/api/api.js";
import { findRoute } from "@/utils/routerHelper.js";

export default {
  name: "ResumeForm",
  components: {
    breadcrumb,
  },
  data() {
    return {
      graduationYears: Array.from(
        { length: 2026 - 1972 + 1 },
        (_, i) => 2026 - i
      ),
      formData: {
        nickName: "",
        personalPhoto: "",
        idNumber: "",
        ethnicity: "",
        politicalStatus: "",
        gender: "",
        birthDate: "",
        major: "",
        highestEducation: "",
        unitNature: "",
        unitName: "",
        professionalTitle: "",
        position: "",
        socialWorkerCertificateLevel: "",
        certificateUpload: [],
        phonenumber: "",
        email: "",
        supportingDocuments: [],
        memberCode: "",
        remark: "",
      },
      rules: {
        personalPhoto: [
          { required: true, message: "请上传个人免冠照片", trigger: "change" },
        ],
        nickName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        idNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
            message: "请输入正确的身份证号码",
            trigger: "blur",
          },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        ethnicity: [
          { required: true, message: "请选择民族", trigger: "change" },
        ],
        politicalStatus: [
          { required: true, message: "请选择政治面貌", trigger: "change" },
        ],
        birthDate: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        major: [{ required: true, message: "请输入所学专业", trigger: "blur" }],
        highestEducation: [
          { required: true, message: "请选择最高学历", trigger: "change" },
        ],
        unitNature: [
          { required: true, message: "请选择单位性质", trigger: "change" },
        ],
        unitName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        professionalTitle: [
          { required: true, message: "请输入职称", trigger: "blur" },
        ],
        position: [
          { required: true, message: "请选择现任职务", trigger: "change" },
          { required: true, message: "请输入现任职务", trigger: "blur" },
        ],
        phonenumber: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
        supportingDocuments: [
          {
            validator: (rule, value, callback) => {
              const needSupportingDocs = [
                "行政事业单位",
                "社会组织",
                "社区备案组织",
              ].includes(this.formData.unitNature);
              if (needSupportingDocs) {
                if (
                  !this.formData.supportingDocuments ||
                  this.formData.supportingDocuments.length === 0
                ) {
                  callback(new Error("请上传证明资料"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        memberCode: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.unitNature === "本协会会员") {
                if (!value || value.trim() === "") {
                  callback(new Error("请输入会员编码"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      loading: false,
      uploadUrl: "https://huachenglargescreen.planttech.cn/apis/common/upload",
      personalPhotoList: [],
      highestEducationCertificateList: [],
      certificateUploadList: [],
      supportingDocumentsList: [],
      position: [
        {
          value: "两委",
          label: "两委",
          children: [
            { value: "正职", label: "正职" },
            { value: "副职", label: "副职" },
            { value: "专职委员", label: "专职委员" },
          ],
        },
        { value: "专职社工岗", label: "专职社工岗" },
        { value: "综合事务岗", label: "综合事务岗" },
        { value: "基础事务岗", label: "基础事务岗" },
        {
          value: "持有社会工作职业资格水平证书人员",
          label: "持有社会工作职业资格水平证书人员",
        },
      ],
      accept: "",
      uploadType: "",
    };
  },
  watch: {
    "formData.unitNature": {
      handler() {
        this.formData.supportingDocuments = [];
        this.supportingDocumentsList = [];
        this.formData.memberCode = "";
        this.$nextTick(() => {
          if (this.$refs.resumeForm) {
            this.$refs.resumeForm.clearValidate([
              "supportingDocuments",
              "memberCode",
            ]);
          }
        });
      },
      immediate: false,
    },
  },
  mounted() {
    if (this.$route.path === "/register/personal") {
      let routerList = [];
      let data2 = findRoute(this.$router.options.routes, "/register/agreement");
      let data3 = findRoute(this.$router.options.routes, "/register/personal");
      if (data2) routerList.push(data2);
      if (data3) routerList.push(data3);
      this.$store.commit("routerData/changeRouterList", routerList);
    }
  },
  methods: {
    onDownload(url) {
      window.open(url, "_blank");
    },
    submitApplication() {
      window.open("https://huacheng.planttech.cn/s/cWlCKdFO", "_blank");
    },
    submitUpload(type) {
      this.accept = type === "image" ? `image/*` : `.${type}`;
      this.uploadType = type;
    },
    submitForm() {
      this.$refs.resumeForm.clearValidate();

      const needSupportingDocs = [
        "行政事业单位",
        "社会组织",
        "社区备案组织",
      ].includes(this.formData.unitNature);
      const isMember = this.formData.unitNature === "本协会会员";

      if (
        needSupportingDocs &&
        (!this.formData.supportingDocuments ||
          this.formData.supportingDocuments.length === 0)
      ) {
        this.$message.error("请上传证明资料");
        return false;
      }

      if (
        isMember &&
        (!this.formData.memberCode || this.formData.memberCode.trim() === "")
      ) {
        this.$message.error("请输入会员编码");
        return false;
      }

      this.$refs.resumeForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          register({
            userName: this.formData.phonenumber,
            nickName: this.formData.nickName,
            phonenumber: this.formData.phonenumber,
            origin: "personal",
            registerInfoTemp: this.formData,
            email: this.formData.email,
          }).then((res) => {
            this.loading = false;
            if (res.data.code == 200) {
              if (res.data.data) {
                this.$message.success("个人用户注册成功");
                setTimeout(() => this.$router.replace("/index"), 1000);
              } else {
                this.$message.error("提交失败，请重新提交");
              }
            } else {
              this.$message.error("提交失败，请重新提交");
            }
          });
        } else {
          this.$message.error("请检查表是否填写完整");
          return false;
        }
      });
    },
    beforeUpload(type = "image", file) {
      if (type === "pdf") {
        const isPDF = file.type === "application/pdf";
        if (!isPDF) {
          this.$message.error("只能上传 PDF 格式的文件！");
          return false;
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error("文件大小不能超过 10MB！");
          return false;
        }
        return true;
      } else {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          this.$message.error("只能上传图片文件！");
          return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB！");
          return false;
        }
        return isImage && isLt2M;
      }
    },
    handleUploadSuccess(propName, response, file, fileList) {
      const imageUrl = response.data;
      if (propName && imageUrl) {
        if (propName === "personalPhoto") {
          this.formData[propName] = imageUrl;
          this.$nextTick(() => {
            this.$refs.resumeForm.validateField("personalPhoto");
          });
        } else {
          this.formData[propName] = fileList.map((item) =>
            item.response ? item.response.data : item.url
          );
        }
        const listName = propName + "List";
        if (this[listName]) {
          this[listName] = fileList;
        }
        this.$message.success("文件上传成功！");
        if (propName === "supportingDocuments") {
          this.$nextTick(() => {
            this.$refs.resumeForm.validateField("supportingDocuments");
          });
        }
      }
    },
    handlePreview(file) {
      if (file.url) {
        window.open(file.url, "_blank");
      } else if (file.raw) {
        const objectUrl = URL.createObjectURL(file.raw);
        window.open(objectUrl, "_blank");
      } else {
        this.$message.warning("无法预览该文件");
      }
    },
    handleRemove(propName, file, fileList) {
      if (propName === "personalPhoto") {
        this.formData[propName] = "";
        this.personalPhotoList = [];
        this.$nextTick(() => {
          this.$refs.resumeForm.validateField("personalPhoto");
        });
      } else {
        this.formData[propName] = fileList.map((item) =>
          item.response ? item.response.data : item.url
        );
        const listName = propName + "List";
        if (this[listName]) {
          this[listName] = fileList;
        }
      }
      if (propName === "supportingDocuments") {
        this.$nextTick(() => {
          this.$refs.resumeForm.validateField("supportingDocuments");
        });
      }
      if (propName === "memberCode") {
        this.$nextTick(() => {
          this.$refs.resumeForm.validateField("memberCode");
        });
      }
    },
    handleExceed() {
      this.$message.warning("个人免冠照片只能上传一张");
    },
    handleImageError(propName, index) {
      this.$message.warning("图片加载失败，已自动移除");
      if (propName === "personalPhoto") {
        this.formData[propName] = "";
        this.personalPhotoList = [];
        this.$nextTick(() => {
          this.$refs.resumeForm.validateField("personalPhoto");
        });
      } else {
        this.formData[propName].splice(index, 1);
        const listName = propName + "List";
        if (this[listName] && this[listName].length > index) {
          this[listName].splice(index, 1);
        }
      }
    },
    handleUploadError(error) {
      console.error("上传失败:", error);
      this.$message.error("上传失败，请稍后重试！");
    },
    resetForm() {
      this.$confirm("确定要重置所有表单数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.resumeForm.resetFields();
        this.personalPhotoList = [];
        this.highestEducationCertificateList = [];
        this.certificateUploadList = [];
        this.supportingDocumentsList = [];
        this.$message.success("表单已重置");
      });
    },
  },
};
</script>

<style scoped>
.page {
  padding: 0 5%;
  padding-bottom: 109px;
  padding-top: 26px;
}
.resume-form {
  width: 80%;
  margin: 0 auto;
  margin-top: 24px;
}
.form-section {
  margin-bottom: 40px;
  padding: 25px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafafa;
}
.section-title {
  color: #2c3e50;
  margin-bottom: 25px;
  padding-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 2px solid #409eff;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  margin-bottom: 20px;
}
.form-row >>> .el-form-item {
  flex: 1;
  min-width: 280px;
  margin-bottom: 20px;
}
.resume-form-content >>> .el-form-item__label {
  white-space: nowrap;
}
.certificate-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 10px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
}
.certificate-group .el-checkbox {
  margin-right: 20px;
  margin-bottom: 10px;
}
.image-preview {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.image-preview img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.image-preview img:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
::v-deep .el-upload__tip {
  line-height: 0 !important;
}
::v-deep .el-upload {
  text-align: left;
}
.form-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 50px;
}
</style>